import { render } from "./VitalsGroupPage.vue?vue&type=template&id=66610e22&scoped=true"
import script from "./VitalsGroupPage.vue?vue&type=script&lang=js"
export * from "./VitalsGroupPage.vue?vue&type=script&lang=js"

import "./VitalsGroupPage.vue?vue&type=style&index=0&id=66610e22&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66610e22"]])

export default __exports__